// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2sFr-","buttons":"RemoveExpirationActionButtons_buttons__1Xp0w"};